import { FileViewer, type IFileViewerProps } from './FileViewer'
import { FileViewerModalStyled } from './styles/FileViewerModalStyled'
import { Modal } from '../Modal'
import { TransparentIconButton } from '@ui/elements/Button'

export interface IFileViewerModalProps extends IFileViewerProps {
  open?: boolean
  onDismiss?: () => void
}

export const FileViewerModal = ({
  open = false,
  onDismiss = () => undefined,
  ...FileViewerProps
}: IFileViewerModalProps) => {
  return (
    <Modal
      maxWidth='sm'
      open={open}
      onClose={onDismiss}
      disableEnforceFocus
      fullScreen
    >
      <FileViewerModalStyled>
        <FileViewer {...FileViewerProps} />
        <TransparentIconButton
          icon='times'
          onClick={onDismiss}
          iconColor='textInverse'
          aria-label='Close file viewer'
          className='close-button'
        />
      </FileViewerModalStyled>
    </Modal>
  )
}

FileViewerModal.displayName = 'FileViewerModal'
